import React from 'react';
import './isi.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function IsiListItem({ el, sub }) {
  const { copy, weight, hyperlink } = el;

  return (
    <li className={sub ? 'isi__body__text isi__body__text--sub' : 'isi__body__text'}>
      {copy
        ? copy.map((text, i) => {
            return weight[i] === 'reg' ? (
              <span key={`listitem-${i}`}>{text}</span>
            ) : (
              <strong
                className={weight[i] === 'bold' ? 'isi__body__bold' : 'isi__body__med'}
                key={`listitem-${i}`}
              >
                {text}
              </strong>
            );
          })
        : el}
      {hyperlink && (
        <span>
          {' '}
          <Hyperlink hyperlinkData={hyperlink} />.
        </span>
      )}
    </li>
  );
}

export default IsiListItem;
